import React, { Dispatch, useCallback } from 'react';
import { ReportFlowStep } from '../constants';
import Spinner, { SpinnerColor } from '../../../generic-components/Spinner';
import ProfitAndLoss from '../pages';
import { BasicAndProIntro } from './steps/basicAndProIntro';
import { SmartAndPremiumIntro } from './steps/smartAndPremiumIntro';
import { Report } from './steps/report';
import { UpgradePlan } from './steps/UpgradePlan';
import { CategorizedWrapper } from './steps/categorizedWrapper';

interface IStepSwitch {
  activeStep?: ReportFlowStep;
  setActiveStep: Dispatch<React.SetStateAction<ReportFlowStep>>;
}

export const StepSwitch = ({ activeStep, setActiveStep }: IStepSwitch) => {
  const getActiveStep = useCallback(() => {
    switch (activeStep) {
      case ReportFlowStep.LOADER:
        return <Spinner spinnerColor={SpinnerColor.Blue} height='2rem' width='2rem' />;
      case ReportFlowStep.INTRO:
        return <SmartAndPremiumIntro setActiveStep={setActiveStep} />;
      case ReportFlowStep.REQUIRED_UPGRADE_PLAN:
        return <BasicAndProIntro />;
      case ReportFlowStep.REPORT:
        return <Report />;
      case ReportFlowStep.CATEGORIZE_TRANSACTIONS:
        return <CategorizedWrapper />;
      case ReportFlowStep.UPGRADE_PLAN:
        return <UpgradePlan />;
      default:
        return <ProfitAndLoss />;
    }
  }, [activeStep]);
  return <>{getActiveStep()}</>;
};
